import {
  SET_LIST_AGENCY,
  SET_AGENCY
} from '@/store/mutation-types'
export default {
  [SET_LIST_AGENCY] (state, agencies) {
    state.agencies = agencies
  },
  [SET_AGENCY] (state, agency) {
    state.agency = agency
  }
}



// WEBPACK FOOTER //
// ./src/components/agency/store/mutations.js